var React = require('react');

function ProductsIcon42Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_58","data-name":"Obszar roboczy 58","transform":"translate(-5.07 -6.15)"},[React.createElement("path",{"id":"Path_395","data-name":"Path 395","d":"M32.39,28.38v.01h-.01Z","fill":"#fff","key":0}),React.createElement("path",{"id":"Path_396","data-name":"Path 396","d":"M19.18,22.28l-.57-9.31h3.04l-.57,9.31H19.17Zm-.41,4.74V24.17H21.5v2.85Z","fill":"#1d1d1b","key":1}),React.createElement("path",{"id":"Path_397","data-name":"Path 397","d":"M8.61,31.86,6.84,29.03H33.18l-1.82,2.83Zm-3.53-5.5L16.74,6.15h3.27L6.79,29.04,5.07,26.37ZM20,6.15h3.27L34.93,26.34l-1.72,2.68Z","key":2})]));
}

ProductsIcon42Inline.defaultProps = {"width":"29.86","height":"25.71","viewBox":"0 0 29.86 25.71"};

module.exports = ProductsIcon42Inline;

ProductsIcon42Inline.default = ProductsIcon42Inline;
